export const loading = "user/loading";
export const failed = "user/failed";
export const login_success = "user/login/success";
export const signup_success = "user/signup/success";
export const logout = "user/logout";
export const clear = "user/clear";